import React from 'react';

import { IconArrow1, IconArrow2 } from '@creditas-ui/icons';
import { Avatar } from '@creditas-ui/avatar';
import { Typography } from '@creditas-ui/typography';
import { removeSession } from '@/shared/application/services';

import * as S from './Responsible.style';

type ResponsibleProps = {
  name: string;
  email: string;
  cellphone: string;
  cellphone_code: string;
};

type ProfileProps = {
  name?: string;
  role?: string;
  source?: string;
  responsible?: ResponsibleProps;
  toggleResponsible: boolean;
  setToggleResponsible: any;
};

type SidebarProfileProps = {
  profile: ProfileProps;
  expanded?: boolean;
  children?: any;
  render?: JSX.Element;
};

const formatPhoneNumber = (code: any, phoneNumber: any) => {
  if (phoneNumber && phoneNumber.length === 9) {
    return `(${code}) ${phoneNumber.substring(0, 1)} ${phoneNumber.substring(
      1,
      5,
    )}-${phoneNumber.substring(5)}`;
  } else {
    return phoneNumber;
  }
};

export const ResponsibleProfile = ({
  expanded = false,
  profile,
  render,
}: SidebarProfileProps): JSX.Element | null => {
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!render) return render;
  if (!profile.responsible) return null;

  const { toggleResponsible, setToggleResponsible } = profile;

  return expanded ? (
    <S.Responsible onClick={() => setToggleResponsible(!toggleResponsible)}>
      <S.TitleResponsible>
        <Typography color="neutral.60" component="p" variant="bodySmMedium">
          Contato Executivo Home
        </Typography>
      </S.TitleResponsible>
      <S.ToogleIconArrow>
        {toggleResponsible ? (
          <IconArrow1 strokeWidth={1} size={24} />
        ) : (
          <IconArrow2 strokeWidth={1} size={24} />
        )}
      </S.ToogleIconArrow>
      {toggleResponsible && (
        <S.ResponsibleData>
          <Typography color="neutral.60" component="p" variant="bodyXsBold">
            {profile.responsible?.name}
          </Typography>
          <Typography color="neutral.60" component="h2" variant="bodyXsRegular">
            {profile.responsible?.email}
          </Typography>
          <Typography color="neutral.60" component="h2" variant="bodyXsRegular">
            {formatPhoneNumber(
              profile.responsible?.cellphone_code,
              profile.responsible?.cellphone,
            )}
          </Typography>
        </S.ResponsibleData>
      )}
    </S.Responsible>
  ) : null;
};
